angular.module('cesium.services', [
  // removeIf(device)
  'cesium.desktop.services',
  // endRemoveIf(device)
  'cesium.settings.services',
  'cesium.http.services',
  'cesium.network.services',
  'cesium.bma.services',
  'cesium.crypto.services',
  'cesium.utils.services',
  'cesium.modal.services',
  'cesium.storage.services',
  'cesium.device.services',
  'cesium.currency.services',
  'cesium.wot.services',
  'cesium.tx.services',
  'cesium.wallet.services',
  'cesium.help.services',
  'cesium.plugin.services'
  ])
;
